import styled from "styled-components";
import { CssRule } from "../../../../../themes/architecture/css-helpers/css-rule";

export const UserMenuCloseIconDefaultBox = styled.div`
    display: flex;
    align-items: center;

    width: 1.4rem;
    height: 1.4rem;
    padding: 0.4rem;
    box-sizing: content-box;
    border: 2px solid ${({ theme }) => theme.colors.boxBorderContrast};
    border-radius: 50%;
    color: ${({ theme }) => theme.colors.textMiddleDark};
    margin-right: 0.5rem;
    ${CssRule.For.mobile.build()} &{
        width: 2rem;
        height: 2rem;
        padding: 0.55rem;
        margin-right: 0;
    }
    &:hover {
        cursor: pointer;
    }
`;